import React from "react";
import { useInstallPrompt } from "../context/InstallPromptContext";

export default function InstallAppButton({ variant = "inline" }) {
  const { isInstallable, promptInstall, prompting, isIos, isStandalone } = useInstallPrompt();
  const [showIosTips, setShowIosTips] = React.useState(false);

  if (isStandalone) return null;

  const handleClick = () => {
    if (isIos) {
      setShowIosTips((prev) => !prev);
      return;
    }
    promptInstall();
  };

  if (!isInstallable && !isIos) return null;

  return (
    <div className={`install-app-cta ${variant === "block" ? "install-app-cta--block" : ""}`}>
      <button
        type="button"
        className="btn-elegant btn-elegant-secondary install-app-btn"
        onClick={handleClick}
        disabled={prompting}
        aria-expanded={isIos ? showIosTips : undefined}
      >
        {isIos ? "Install on iOS" : prompting ? "Preparing..." : "Install App"}
      </button>
      {isIos && showIosTips && (
        <div className="install-ios-tips">
          <p>1. Tap the <strong>Share</strong> icon in Safari.</p>
          <p>2. Choose <strong>Add to Home Screen</strong>.</p>
          <p>3. Confirm the name &amp; tap <strong>Add</strong>.</p>
        </div>
      )}
    </div>
  );
}


